import { useCallback } from "react";
import FormTextField from "../components/Catalog/components/form-text-field/FormTextField";
import FormNumberField from "../components/Catalog/components/form-number-field/FormNumberField";
import FormCalendar from "../components/Catalog/components/form-calendar/FormCalendar";
import FormCheckbox from "../components/Catalog/components/form-checkbox/FormCheckbox";
import FormDropdown from "../components/Catalog/components/form-dropdown/FormDropdown";

const useRenderField = (control, errors) => {
    return useCallback((
        code,
        {
            name, placeholder, valueMode, onOptionSelect, label = "", inputType = "text",
            selectionMode = "single", labelField = "nameRu", required = false,
            disabled = false, inputCentered = false
        },
        key
    ) => {
        const getDropdownCode = () => {
            if (name === "activity") {
                return name;
            }

            return code === "operation-types" ? "taxes" : "basic-values";
        }

        switch (inputType) {
            case "text":
                return (
                    <FormTextField key={key}
                                   name={name}
                                   label={label}
                                   placeholder={placeholder}
                                   control={control}
                                   errors={errors}
                                   required={required}
                                   disabled={disabled}
                                   inputCentered={inputCentered}
                    />
                )
            case "number":
                return (
                    <FormNumberField key={key}
                                     name={name}
                                     label={label}
                                     placeholder={placeholder}
                                     control={control}
                                     errors={errors}
                                     required={required}
                                     disabled={disabled}
                    />
                );
            case "date":
                return (
                    <FormCalendar key={key}
                                  name={name}
                                  label={label}
                                  placeholder={placeholder}
                                  control={control}
                                  errors={errors}
                                  required={required}
                                  disabled={disabled}
                                  selectionMode={selectionMode}
                    />
                );
            case "boolean":
                return <FormCheckbox key={key}
                                     name={name}
                                     label={label}
                                     control={control}
                                     required={required}
                                     disabled={disabled}
                />;
            case "dropdown":
                const dropdownCode = getDropdownCode();

                return (
                    <FormDropdown key={key}
                                  code={dropdownCode}
                                  name={name}
                                  label={label}
                                  placeholder={placeholder}
                                  valueMode={valueMode}
                                  control={control}
                                  errors={errors}
                                  required={required}
                                  disabled={disabled}
                                  onOptionSelect={onOptionSelect}
                                  labelField={labelField}
                    />
                )
            default:
                return null;
        }
    }, [control, errors]);
};

export default useRenderField;